import { SelectOption } from "@/types/inputField"

export const GOOGLE_AUTH_SCOPE_DRIVE = 'https://www.googleapis.com/auth/drive.file'
export const GOOGLE_AUTH_SCOPE_USERINFO_PROFILE = 'https://www.googleapis.com/auth/userinfo.profile'
export const GOOGLE_AUTH_SCOPE_USERINFO_EMAIL = 'https://www.googleapis.com/auth/userinfo.email'

export enum TCS {
  TARGET_WORKFLOWS_COUNT = 200,
  SUPPORT_EMAIL = 'support@thecampstack.com',
  GOOGLE_AUTH_SCOPE = `${GOOGLE_AUTH_SCOPE_DRIVE} ${GOOGLE_AUTH_SCOPE_USERINFO_PROFILE} ${GOOGLE_AUTH_SCOPE_USERINFO_EMAIL}`,
  GOOGLE_AUTH_CLIENT_ID_SANDBOX = '732722485708-dooqujgdgmaorvhf7vq2uipvf22tvou0.apps.googleusercontent.com',
  GOOGLE_AUTH_CLIENT_ID_PRODUCTION = '903743684409-n91gel3dqtv6qg515f2552kc3bmr9qkm.apps.googleusercontent.com',
  GOOGLE_SHEET_TOKEN_LIFE_SPAN = 90,
  GOOGLE_APP_ID_SANDBOX = "732722485708",
  GOOGLE_APP_ID_PRODUCTION = "903743684409",
}

export const AVAILABLE_METHODS = {
  SBM: ['Get Riders']
}

export enum AppAvailabilityStatus {
  ACTIVE = 'active',
  COMING_SOON = 'coming_soon',
  IN_ACTIVE = 'inactive'
}

export enum App {
  TCS = 'the_camp_stack',
  SBM = 'school_bus_manager'
}

export const TCSAPP = {
  [App.TCS]: 'The Camp Stack',
  [App.SBM]: 'School Bus Manager'
}

export enum FieldUpdateType {
  CUSTOM_FIELD = 'custom_fields',
  DAY_CAMP_TRAVEL = 'day_camp_travel'
}

export enum OperationMethod {
  EDIT = 'edit',
  CREATE = 'create'
}

export enum FieldOptionType {
  FIRST = 'first',
  LAST = 'last',
  INDEX = 'index',
  COMMA_SEPARATED = 'commaSeparated'
}

export const FIELD_OPTION_SELECT_OPTIONS: SelectOption[] = [
  {
    id: FieldOptionType.FIRST,
    value: 'First',
    description: 'Pick the first item'
  },
  {
    id: FieldOptionType.LAST,
    value: 'Last',
    description: 'Pick the last item'
  },
  {
    id: FieldOptionType.INDEX,
    value: 'Indexes',
    description: 'Select values by indexes (0 based)'
  },
  {
    id: FieldOptionType.COMMA_SEPARATED,
    value: 'Comma separated',
    description: 'Combine values into a single string separated by commas'
  }
]
